import { createSelector } from 'reselect';

import { offerSelector } from './offer';

export const offerPhonesSelector = createSelector(offerSelector, offer => offer.phones ?? []);
